import React, {useState, useEffect} from 'react'
import { useNavigate } from "react-router-dom";
import './MarketMenu.css'
import MarketMenuItem from './MarketMenuItem'
import {Zoom} from 'react-awesome-reveal';
import { fetchItemsByCategoryHandle } from '../../lib/ShopifyUtility';
import LoadingPage from '../pages/LoadingPage';
// import DropdownButtonComponent from '../dropdowns/DropdownButtonComponent';
import SlidingNavbar from '../SlidingNavbar';

const MarketMenuCategory = ({catName, catHandle, onAddToBasket}) => {

    const [items, setItems] = useState([]);
    const [loadingItems, setLoadingItems] = useState(true);

    useEffect(() => {
      let isMounted = true; // Use a flag to check if the component is still mounted
      const currentCatHandle = catHandle;
    
      setLoadingItems(true);
    
      fetchItemsByCategoryHandle(catHandle).then((items) => {
        // Check if the current category slug matches the stored category slug
        if (isMounted && currentCatHandle === catHandle) {
          setItems(items);
          setLoadingItems(false);
        }
      });
    
      return () => {
        isMounted = false; // Set the flag to false when the component is unmounted
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catHandle]);

    // const dropDownItems = {
    //   'ALPHABETICAL': 'fetchItemsByCategorySortedAlpha',
    //   'ALPHABETICAL REVERSE': 'fetchItemsByCategorySortedAlphaRev',
    //   'PRICE LOW TO HIGH': 'fetchItemsByCategorySortedPriceLowHigh',
    //   'PRICE HIGH TO LOW': 'fetchItemsByCategorySortedPriceHighLow'
    // }

    let navigate = useNavigate();

    const handleCatReturn = () => {
      window.scroll(0, 0);

      navigate('/market');
    }

  return (
    <>
      <SlidingNavbar catName={catName}/>
      <div className='cat_option_container'>
        <Zoom triggerOnce={true}>
          <button className='cat_return_btn' onClick={handleCatReturn}>&#8678; BACK</button>
        </Zoom>
        {/*<Zoom triggerOnce={true}>*/}
        {/*  <DropdownButtonComponent btnTxt={'SORT '} dropDownItems={dropDownItems}/>*/}
        {/*</Zoom>*/}
      </div>
      
        <div className='market_menu_cat'>
            <Zoom triggerOnce={true}>
              <h2 style={{maxWidth:'350px'}}>{catName}</h2>
            </Zoom>
            {loadingItems ? (
            <LoadingPage height="600px" />
            ) : items ? (
                <ul className='menu_grid'>
                    {items.map((item) => (
                        <MarketMenuItem item={item} key={item.id} onAddToBasket={onAddToBasket} catHandle={catHandle}/>
                    ))}
                </ul>
            ) : (
              <Zoom triggerOnce={true}>
                <p className='no_items_in_category'>There are currently no items in this category, sorry :(</p>
              </Zoom>
            )}
        </div>
    </>
  )
}

export default MarketMenuCategory
